import { Box } from '@mui/material';
import React, { ReactElement } from 'react';
import type { AttendeeRole } from 'services/api';

const OUTLINE_COLOR = '#383838';

export function AttendeeRolePill ({
  role,
}: {
  role: AttendeeRole;
}): ReactElement | null {
  if (!role) return null;

  const isWide = role === 'Org Leader';

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: isWide ? 'auto' : 100,
        px: isWide ? '16px' : 0,
        py: '4px',
        borderRadius: '9999px',
        border: `1px solid ${OUTLINE_COLOR}`,
        backgroundColor: 'white',
        color: OUTLINE_COLOR,
        fontFamily: '\'Poppins\', sans-serif',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '18px',
        whiteSpace: 'nowrap',
      }}
    >
      {role}
    </Box>
  );
}
